import { css } from 'lit';

export const styles = css `
  .container {
    font-family: var(--u-font-family, var(--u-font-family, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"));
    line-height: var(--u-drawer-headline-line-height, var(--u-title-s-line-height, 1.25rem));
    font-size: var(--u-drawer-headline-font-size, var(--u-title-s-font-size, 0.875rem));
    letter-spacing: var(--u-drawer-headline-letter-spacing, var(--u-title-s-letter-spacing, 0.0071428571rem));
    font-weight: var(--u-drawer-headline-font-weight, var(--u-title-s-font-weight, var(--u-font-weight-medium, 500)));
    color: var(--u-drawer-headline-color, var(--u-color-on-surface-variant, rgb(73, 69, 79)));
    margin-block: var(--u-drawer-headline-margin-block, 16px 24px);
  }
`;
